import {ScreenProps} from "../../../../../../utils/screen-props-helper";
import {useWorkOrder} from "../../WorkOrdersStack";
import React, {useEffect, useState} from "react";
import {FlatList, ListRenderItemInfo, View} from "react-native";
import {useLazyGetWorkOrderJobPlansQuery, useSetConfirmJobPlanMutation} from "../../../../../../store/services/api/work-order-api";
import {JobPlan} from "../../../../../../store/data/entities/job-plan";
import {TechnicianJobPlansStackParamList} from "./TechnicianJobPlansStack";
import {Button, Card} from "react-native-paper";
import Skeleton from "../../../../../../components/skeletons/Skeleton";
import {EmptyList} from "../../../../../../components/flatlist/EmptyList";
import {Checkbox, Text} from "react-native-paper";
import { WorkOrderType } from "../../../../../../store/data/entities/work-order";

export default function TechnicianJobPlansList({navigation}: ScreenProps<TechnicianJobPlansStackParamList, 'jobPlans'>) {
  const {id, workOrder} = useWorkOrder();
  const [getJobPlans, {data, isFetching}] = useLazyGetWorkOrderJobPlansQuery();
  const [setConfirmJobPlan] = useSetConfirmJobPlanMutation();

  const handleConfirmJobPlan = async () => {
  if (workOrder?.confirmedJobPlan) return;

  if (id) {
    await setConfirmJobPlan({
      entityId: id,
      confirmed: true
    });

    setHasReadJobPlan(true);
  }
};
  useEffect(() => {
  if (workOrder) {
    setHasReadJobPlan(workOrder.confirmedJobPlan ?? false);
    }
  }, [workOrder]);

  useEffect(() => {
  if (workOrder?.type !== WorkOrderType.Preventative) {
    return;
  }
  
  if (id && workOrder?.type === WorkOrderType.Preventative) {
    getJobPlans(id);
  }
}, [id, workOrder?.type]);
  const [hasReadJobPlan, setHasReadJobPlan] = useState(workOrder?.confirmedJobPlan ?? false);
  const renderJobPlan = ({item}: ListRenderItemInfo<JobPlan>) => {
    const handleOnPress = () => navigation.navigate('details', {id: item.id})

    return (
      <Card style={{backgroundColor: 'white'}}>
        <Card.Title title={item.reference} subtitle={item.title} />
        <Card.Actions>
          <Button onPress={handleOnPress}>View</Button>
        </Card.Actions>
      </Card>
    )
  }

  return (
    <Skeleton
      loading={isFetching}
      placeholder={<Skeleton.Card />}
    >
      <FlatList
        style={{paddingHorizontal: 4, paddingVertical: 6}}
        ItemSeparatorComponent={() => <View style={{height: 6}} />}
        data={data ?? []}
        renderItem={renderJobPlan}
        ListEmptyComponent={
          <EmptyList
            isLoading={isFetching}
            emptyText={'There are no job plans assign to this work order.'}
          />
        }
        ListFooterComponent={
          <View style={{flexDirection: 'row', alignItems: 'center', marginTop: 16}}>
            <Checkbox
              disabled={workOrder?.confirmedJobPlan}
              status={hasReadJobPlan ? 'checked' : 'unchecked'}
              onPress={handleConfirmJobPlan}
            />
            <Text>I have read and understood the job plan</Text>
          </View>
        }
      />
    </Skeleton>
  );
}
